import { smrApi } from '@/utils/axios-config'

const apiBase = 'email';

export default {
    shareUrlViaEmail(email, url) {
        const params = {
            to: email,
            textOnly: false,
            data: {
                routeLink: url
            }
        }
        return smrApi.post(`${apiBase}/email/smr-share-route/send`, params);
    }
}